// src/utils/crypto.js
// Small helpers used by the Employee Docs Portal feature.

export async function sha256Hex(input) {
  const enc = new TextEncoder();
  const data = enc.encode(String(input));
  const hashBuffer = await crypto.subtle.digest("SHA-256", data);
  const hashArray = Array.from(new Uint8Array(hashBuffer));
  return hashArray.map((b) => b.toString(16).padStart(2, "0")).join("");
}

export function random6DigitCode() {
  return String(Math.floor(100000 + Math.random() * 900000));
}

export function randomToken() {
  // Prefer a real UUID if available
  if (typeof crypto !== "undefined" && crypto.randomUUID) return crypto.randomUUID();
  // Fallback: reasonably random token
  return (
    "tok_" +
    Math.random().toString(36).slice(2) +
    "_" +
    Date.now().toString(36)
  );
}
